// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"f72dd5ed","64":"4d215649","160":"9da66d82","316":"05368a60","340":"4d215649","420":"ce2adb0c","709":"cdda9632"}[chunkId] + ".chunk.css";
};